export default __webpack_public_path__ + "static/media/SipatNexa-Logo-branca.65057ddc.png";